import { createContext } from "react";

const AppContext: any = createContext(null);
export default AppContext;
